import { isDefined } from "@clipboard-health/util-ts";
import { type Location } from "@src/appV2/lib/GoogleMaps";

interface ConstructAppleMapUrlOptions {
  location: Location;
  formattedAddress?: string;
}

/**
 * Constructs an Apple Maps URL for a given location.
 *
 * Uses `ll` for map centering and `q` for the search/routing pin.
 * When an address is provided, it's set as `q` so Apple Maps uses it
 * for directions routing (anchored near the `ll` coordinates), avoiding
 * the re-geocoding issue that occurs with the separate `address` parameter.
 */
export function constructAppleMapUrl(options: ConstructAppleMapUrlOptions): string {
  const { location, formattedAddress } = options;
  const baseUrl = "http://maps.apple.com";
  const searchParams = new URLSearchParams();

  const coordinates = `${location.lat},${location.lng}`;
  searchParams.set("ll", coordinates);
  searchParams.set("q", isDefined(formattedAddress) ? formattedAddress : coordinates);

  return `${baseUrl}?${searchParams.toString()}`;
}
